/**
 * 有効期限日時を渡して、期限が切れているかどうかを返す
 * @param limit 有効期限日時
 */
export const isExpired = (limit: string): boolean => {
  return new Date(limit).getTime() < new Date().getTime()
}

export default isExpired
